import { jsx as _jsx } from "react/jsx-runtime";
import { RouterProvider as TanStackRouterProvider, } from '@tanstack/react-router';
import { router, } from './router.js';
export function RouterProvider() {
    return _jsx(TanStackRouterProvider, { router: router() });
}
//# sourceMappingURL=RouterProvider.js.map